import { useParams } from "react-router-dom";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useGetSimple } from "../../services/GetService";

import Input from "../inputs/Input";
import Select from "../inputs/Select";
import TextArea from "../inputs/TextArea";

import toast, { Toaster } from "react-hot-toast";
import "../../../../sass/forms/getFroms.scss";
import GRecaptcha from "../recaptcha/GRecapcha";
import sendMail from "./Service";
import useGetStyles from "./GetStyles";

const ContactForm = () => {
    const { slug } = useParams();
    const [recaptchaInstance, setRecaptchaInstance] = useState(null);
    const [recaptcha, setRecapcha] = useState("");
    const [sending, setSending] = useState(false);

    const {
        register,
        handleSubmit,
        reset,
        formState: { errors },
    } = useForm();

    const [form] = useGetSimple(slug);
    const style = useGetStyles();

    /**
     * "onSubmit" is a function that sends an email to a user.
     * @param data - the form data
     */
    const onSubmit = async (data) => {
        const slug = form.form_code;

        /* Sending the form data to the server. */
        const send = await sendMail(
            data,
            recaptcha,
            recaptchaInstance,
            slug,
            setSending
        );

        /* Showing a message to the user. */
        if (send.success) {
            toast.success(send.message);
            reset();
            window.parent.postMessage({
                event: 'form_submit_success',
                companySlug: form.slug
            }, '*');
        } else {
            toast.error(send.message);
        }
    };

    const divStyle = {
        backgroundColor: sending ? "#A7A7A7" : "#" + style.buttonbg,
        border: 0,
        color: "#" + style.buttonColor,
    };

    return (
        <div className={`container-fluid `}>
            <Toaster position="end-center" reverseOrder={false} />
            <div className={form.slug}>
                <div className="col-12">
                    {form.form_input && (
                        <form
                            className={`form ${style.style} ${style.color}`}
                            onSubmit={handleSubmit(onSubmit)}
                        >
                            <div
                                className={`form-body row  d-flex justify-content-center`}
                            >
                                {form.form_input.map((item) => {
                                    switch (item.input.type) {
                                        case "input":
                                            return (
                                                <Input
                                                    key={item.id}
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                    where={"form"}
                                                    color={style.inputColor}
                                                    background={style.inputbg}
                                                    border={style.inputBorde}
                                                    inline={style.inline}
                                                    showlabel={style.showlabel}
                                                />
                                            );
                                        case "text_area":
                                            return (
                                                <TextArea
                                                    key={item.id}
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                    where={"form"}
                                                    color={style.inputColor}
                                                    background={style.inputbg}
                                                    border={style.inputBorde}
                                                    inline={style.inline}
                                                    showlabel={style.showlabel}
                                                />
                                            );
                                        case "select":
                                            return (
                                                <Select
                                                    key={item.id}
                                                    input={item}
                                                    register={register}
                                                    errors={errors}
                                                    where={"form"}
                                                    color={style.inputColor}
                                                    background={style.inputbg}
                                                    border={style.inputBorde}
                                                    selectbg={style.selectbg}
                                                    inline={style.inline}
                                                    showlabel={style.showlabel}
                                                />
                                            );
                                        default:
                                            return <h1>nada</h1>;
                                    }
                                })}

                                <div className="d-none btn-submit col-12 text-center">
                                    <GRecaptcha
                                        siteKey="6Lds4rsfAAAAAAdtc1PmKQrxuSwWD15gbTlTFOP0"
                                        recaptchaInstance={recaptchaInstance}
                                        setRecaptchaInstance={
                                            setRecaptchaInstance
                                        }
                                        setRecapcha={setRecapcha}
                                    />
                                </div>

                                <div
                                    className={`btn-submit ${style.inline != false
                                        ? style.inline
                                        : "col-12"
                                        }  ${style.btnposition} p-4`}
                                >
                                    <button
                                        className={`btn-send`}
                                        style={divStyle}
                                        disabled={sending ? true : false}
                                    >
                                        {sending ? "Enviando..." : "Enviar"}
                                    </button>
                                </div>
                            </div>
                        </form>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ContactForm;
